var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('DemoBoard',{attrs:{"isPublic":true}})}
var staticRenderFns = []

export { render, staticRenderFns }